<template>
  <div>
    <div class="webcam-wrapper">
      <div class="webcam">
        <video
          class="webcam-live"
          ref="videoEl"
          width="1080"
          height="1080"
          v-bind:class="{ flip: isFlipped }"
          autoplay=""
          playsinline=""
          v-show="!captured"
        ></video>
        <canvas class="final-image" ref="canvasEl" width="1080" height="1080"></canvas>
        <img class="overlay-image" :src="overlayImgUrl" v-show="overlayImgUrl" />
        <div class="counter-label" v-bind:class="{ 'counter-label-scale': counterScale }">{{ counterValue }}</div>
        <div class="white-flash" :style="{ opacity: flashOpacity }"></div>
        <div class="camera-flip" v-show="captureMode"><img @click="flip" :src="cameraFlipUrl" /></div>
      </div>

      <div class="start-capture-panel" v-show="captureMode">
        <div class="btn" style="min-width: 100%" @click="startCapture">
          <span v-html="$t('theme.btnText')"></span>
        </div>
      </div>

      <div style="margin-top: 1rem" v-show="!captured && !capturing">
        <a @click="uploadImg" class="file-upload" v-html="$t('theme.fileUpload')"></a>
      </div>

      <div class="confirm-capture-panel" style="" v-show="captured">
        <a @click="restartCapture" class="ko-btn btn">
          <img style="pointer-events: none;" :src="koIconUrl" />
        </a>

        <a @click="imgOk" class="ok-btn btn">
          <img style="pointer-events: none;" :src="okIconUrl" />
        </a>
      </div>
    </div>
    <audio ref="snapSound" :src="snapSoundUrl" preload="auto"></audio>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies

const snapSoundUrl = require('../assets/snap.mp3');
const cameraFlipUrl = require('../assets/camera-flip.svg');
const okIconUrl = require('../assets/ok.svg');
const koIconUrl = require('../assets/ko.svg');

export default {
  name: 'LiveView',

  components: {},
  directives: {},

  props: {
    layout: null,
  },

  data() {
    return {
      facingMode: '', // user but back
      streaming: false,
      counterValue: '',
      counterScale: false,
      flashOpacity: 0,
      captured: false,
      capturing: false,
      snapSoundUrl,
      cameraFlipUrl,
      okIconUrl,
      koIconUrl,
      notSupported: !navigator.mediaDevices,
    };
  },

  computed: {
    isFlipped() {
      return this.facingMode === 'user';
    },

    captureMode() {
      return this.streaming && !this.capturing;
    },

    overlayImgUrl() {
      return this.layout && this.layout.overlay;
    },
  },

  mounted() {
    this.start();
  },

  beforeDestroy() {
    this.stop();
  },

  methods: {
    start() {
      const layoutImg = new Image();

      const preloadDone = () => {
        this.go();
      };

      layoutImg.onload = preloadDone;
      layoutImg.onerror = preloadDone;
      layoutImg.src = this.layout && this.layout.overlay;
    },

    accessDeniedCheck() {
      const { userAgent } = navigator;

      const ios = /iphone|ipod|ipad/.test(userAgent);
      const safari = /safari/.test(userAgent);

      console.log('IOS, safari:', ios, safari, userAgent);

      if (userAgent.match('CriOS') || (ios && !safari)) {
        // https://stackoverflow.com/questions/13807810/ios-chrome-detection
        // eslint-disable-next-line no-alert
        alert('The camera access is not supported by this brower, please open this page with Safari.');
        // L’accès à votre camera n’est pas supporté par chrome iOs veuillez ouvrir cette page avec Safari.
      } else {
        this.$emit('accessDenied');
      }
    },
    go() {
      const { videoEl } = this.$refs;

      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        console.log('No navigator.mediaDevices');
        this.accessDeniedCheck();
        return;
      }

      // display info

      navigator.mediaDevices
        .getUserMedia(this.getMediaConstraints()) // get permisson from user
        .then((stream) => {
          this.info();

          this.stream = stream;
          videoEl.srcObject = stream;
          videoEl.play();
          this.streaming = true;
        })
        .catch((error) => {
          console.log('Start error:', error);

          this.accessDeniedCheck();

          // eslint-disable-next-line no-alert
          // alert('Camera access denied, please refresh this page and allow access to your camera.');
          this.streaming = false;
        });
    },

    getMediaConstraints() {
      const constraints = {
        video: {
          facingMode: this.facingMode,
          // if specifi webcam videoConstraints.deviceId

          width: {
            ideal: 1080,
          },
          height: {
            ideal: 1080,
          },
        },
        audio: false,
      };

      return constraints;
    },

    flip() {
      this.facingMode = this.facingMode === 'user' ? 'environment' : 'user';
      // console.log('Flippp', this.facingMode);
      this.start();
    },

    startCapture() {
      if (this.capturing) {
        return;
      }

      this.capturing = true;
      this.counterValue = 3;
      this.countDown();

      // this.showFlash(); // no countdown
    },

    restartCapture() {
      this.captured = false;
      this.capturing = false;

      // clear canvas
      const { canvasEl } = this.$refs;
      const context = canvasEl.getContext('2d');
      context.clearRect(0, 0, canvasEl.width, canvasEl.height);

      this.start();
    },

    countDown() {
      this.counterScale = true;

      setTimeout(() => {
        this.counterScale = false;

        setTimeout(() => {
          this.counterValue -= 1;

          if (this.counterValue > 0) {
            this.countDown();
          } else {
            this.showFlash();
          }
        }, 260);
      }, 900);
    },

    stop() {
      if (this.stream) {
        this.stream.getTracks().forEach((track) => {
          track.stop();
        });

        this.stream = null;
        this.streaming = false;
      }
    },

    uploadImg() {
      this.$emit('fileUpload');
    },

    imgOk() {
      console.log('Click');
      this.$emit('imgOK');

      // this.downloadImg(imgBlob);
    },

    processImg() {
      const { canvasEl } = this.$refs;
      const imgData = canvasEl.toDataURL('image/jpeg', 0.95); /* 'image/png' */
      const imgBlob = this.b64toBlob(imgData, 'image/jpeg');
      return imgBlob;
    },

    downloadImg(fileData) {
      const a = document.createElement('a');
      const url = URL.createObjectURL(fileData);
      a.href = url;
      a.download = 'demo.png';
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    },

    showFlash() {
      this.$refs.snapSound.play();

      this.flashOpacity = 1;
      setTimeout(() => {
        this.flashOpacity = 0;
      }, 360);

      const { videoEl, canvasEl } = this.$refs;
      const context = canvasEl.getContext('2d');

      // reset canvas
      context.setTransform(1, 0, 0, 1, 0, 0);
      context.clearRect(0, 0, canvasEl.width, canvasEl.height);

      if (this.facingMode === 'user') {
        // console.log('Flip canvas');
        context.translate(canvasEl.width, 0);
        context.scale(-1, 1);
      } else {
        // console.log('Canvas not flipped');
      }

      const scale = Math.max(canvasEl.width / videoEl.videoWidth, canvasEl.height / videoEl.videoHeight);
      // get the top left position of the image
      const x = canvasEl.width / 2 - (videoEl.videoWidth / 2) * scale;
      const y = canvasEl.height / 2 - (videoEl.videoHeight / 2) * scale;

      // console.log(x, y, videoEl.videoWidth * scale, videoEl.videoHeight * scale);
      context.drawImage(videoEl, x, y, videoEl.videoWidth * scale, videoEl.videoHeight * scale);
      // const data = canvasEl.toDataURL('image/png');

      this.stop();
      this.capturing = false;
      this.captured = true;
    },

    async info() {
      return new Promise((resolve, reject) => {
        navigator.mediaDevices
          .enumerateDevices()
          .then((devices) => {
            for (let i = 0; i < devices.length; i += 1) {
              const tempDevice = devices[i];
              // console.log(tempDevice);
              console.log('input:', tempDevice.kind, tempDevice.label, tempDevice.facingMode);
              if (tempDevice.kind === 'videoinput') {
                if (tempDevice.facingMode === 'environment' || tempDevice.label.indexOf('facing back') >= 0) {
                  //
                }
              }
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /*
    getVideoInputs(mediaDevices) {
      this.webcamList = [];
      mediaDevices.forEach((mediaDevice) => {
        if (mediaDevice.kind === 'videoinput') {
          this.webcamList.push(mediaDevice);
        }
      });
      if (this.webcamList.length === 1) {
        this.webcamList = 'user';
      }
      return this.webcamList;
    }, */

    b64toBlob(dataURI, contentType = 'image/png', sliceSize = 512) {
      const byteCharacters = atob(dataURI.split(',')[1]);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i += 1) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
  },
};
</script>

<style lang="scss">
.file-upload {
  text-decoration: underline;
  cursor: pointer;
}

.flip {
  transform: scaleX(-1);
  -moz-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  -ms-transform: scaleX(-1);
  -o-transform: scaleX(-1);
}

.overlay-image {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 1;
  z-index: 3;
  border-radius: 8px;
}

.final-image {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  border-radius: 8px;
}

.webcam-wrapper {
  margin: 0 auto;
  display: inline-block;
}

.webcam {
  position: relative;
  background: #313131;
  border-radius: 8px;
  //https://loading.io/asset/407447
  //background-image: url("../assets/ball-loading.gif");

  background-repeat: no-repeat;
  background-position: center;

  overflow: hidden;
}

.camera-flip {
  position: absolute;
  right: 4px;
  padding: 4px;
  top: 4px;

  background: rgba(0, 0, 0, 0.4);
  z-index: 18;
  border-radius: 4px;
}

.camera-flip img {
  height: 24px;
  vertical-align: top;
}

.webcam-live {
  object-fit: cover;
  display: block;
  border-radius: 8px;
}

.white-flash {
  background: rgba(255, 255, 255, 0.88);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;

  transition: all 0.1s linear;

  z-index: 10;
}

.counter-label {
  color: #ffffff;
  font-weight: 700;
  font-size: 100px;
  position: absolute;
  text-align: center;
  left: 45%;
  top: 50%;
  right: 50%;
  opacity: 0;
  transform: scale(1) translate(-50%, -50%);
  -moz-transform: scale(1) translate(-50%, -50%);
  -webkit-transform: scale(1) translate(-50%, -50%);
  transition: all 0.2s;
  -moz-transition: all 0.2s;
  -webkit-transition: all 0.2s;

  z-index: 5;
}

.counter-label-scale {
  opacity: 1;
  transform: scale(1) translate(-50%, -50%);
  -moz-transform: scale(1) translate(-50%, -50%);
  -webkit-transform: scale(1) translate(-50%, -50%);
}

.webcam,
.webcam-live,
.overlay-image,
.final-image {
  height: 320px !important;
  width: 320px !important;
}

.start-capture-panel {
  margin-top: 1.2rem;
}

.confirm-capture-panel {
  margin: 0 auto;
  margin-top: 1.2rem;
  display: flex;
  justify-content: space-between;
}

.confirm-capture-panel .ok-btn img,
.confirm-capture-panel .ko-btn img {
  height: 40px;
  vertical-align: top;
}

.confirm-capture-panel .ok-btn,
.confirm-capture-panel .ko-btn {
  padding: 0.6em;

  cursor: pointer;
}

@media only screen and (max-width: 320px) {
  .webcam,
  .webcam-live,
  .overlay-image,
  .final-image {
    height: 300px !important;
    width: 300px !important;
  }
}

@media only screen and (min-width: 768px) {
  .webcam,
  .webcam-live,
  .overlay-image,
  .final-image {
    height: 320px !important;
    width: 320px !important;
  }
  .camera-flip {
    display: none !important;
  }
}
</style>
